"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DataAccessor_1 = require("../../DOM/HTMLElement/DataAccessor");
class AttributeMap {
    constructor(element) {
        this.element = element;
        this.dataAccessor = new DataAccessor_1.default((context, key) => { var _a; return (_a = context.getAttribute(key)) !== null && _a !== void 0 ? _a : undefined; }, 
        // AttributeMap does not support setting undefined values. But DataAccessor does, so we can not hit this in UT
        // istanbul ignore next
        (context, key, value) => context.setAttribute(key, value !== null && value !== void 0 ? value : ''));
    }
    toggle(key, forceValue) {
        if (forceValue !== undefined) {
            this.setBool(key, forceValue);
            return this;
        }
        const current = this.element.getAttribute(key);
        this.setBool(key, current === null || current === 'false');
        return this;
    }
    getInt(key, defaultValue) {
        return this.dataAccessor.getInt(this.element, key, defaultValue);
    }
    setInt(key, value) {
        this.dataAccessor.setInt(this.element, key, value);
    }
    getFloat(key, defaultValue) {
        return this.dataAccessor.getFloat(this.element, key, defaultValue);
    }
    setFloat(key, value) {
        this.dataAccessor.setFloat(this.element, key, value);
    }
    getString(key, defaultValue) {
        return this.dataAccessor.getString(this.element, key, defaultValue);
    }
    setString(key, value) {
        this.dataAccessor.setString(this.element, key, value);
    }
    getDate(key, defaultValue) {
        return this.dataAccessor.getDate(this.element, key, defaultValue);
    }
    setDate(key, value) {
        this.dataAccessor.setDate(this.element, key, value);
    }
    getJson(key, defaultValue) {
        return this.dataAccessor.getJson(this.element, key, defaultValue);
    }
    setJson(key, value) {
        this.dataAccessor.setJson(this.element, key, value);
    }
    setBool(key, value) {
        if (value) {
            this.dataAccessor.setString(this.element, key, key);
            return;
        }
        this.element.removeAttribute(key);
    }
    has(key) {
        return this.element.hasAttribute(key);
    }
}
HTMLElement.prototype.attributeMap = function attributeMap() {
    return new AttributeMap(this);
};
//# sourceMappingURL=AttributeMap.js.map